export enum StorageEnum {
  SESSION_ID = 'session',
  TEAM_ID = 'team',
  ADMIN_TEAM_ID = 'admin_team',
  BRAND_ID = 'brand',
  APP_ENVIRONMENT = 'app_environment',
  SELECTED_ORDER = 'selected_order',
  OFFLINE_PRODUCTS_ENCRYPTION_KEY = 'offline_products_encryption_key',
  ORDER_BOOK = 'order_book',
  CUSTOM_CATALOG_SNAPSHOT = 'custom_catalog_snapshot',
  CAMERA_ID = 'camera_id',
  PRODUCT_DETAILS_FILTER = 'product_details_filter',
  FORCE_OFFLINE = 'force_offline',
  LAST_LOGIN_WAS_FROM_A_BRAND = 'last_login_was_from_a_brand',
  EXPORT_ORDER_MODAL_CONFIG = 'export_order_modal_config',
  SHOW_ORDER_VALUE = 'show_order_value',
  GLOBAL_SEARCH_RECENTS = 'global_search_recents',
  DISMISSED_ANNOUNCEMENT = 'dismissed_announcement',
  READ_HIGHLIGHTS = 'read_highlights',
  SIDEBAR_STATE = 'sidebar_state',
}
